import { combineReducers } from "redux";
import { authorizationReportReducer } from "./accounting/authorizationReportReducer";
import { complementReducer } from "./accounting/complementReducer";
import { deductionTypeReducer } from "./accounting/deductionTypeReducer";
import { downloadXMLRequestReducer } from "./accounting/downloadXMLRequestReducer";
import { downloadXmlSatStatisticsReducer } from "./accounting/downloadXmlSatStatisticsReducer";
import { expenseDepresiationReducer } from "./accounting/expenseDepresiationReducer";
import { expenseReducer } from "./accounting/expenseReducer";
import { expenseTypeReducer } from "./accounting/expenseTypeReducer";
import { incomeReducer } from "./accounting/incomeReducer";
import { IsrHonorariumReducer } from "./accounting/IsrHonorariumReducer";
import { isrLeaseReducer } from "./accounting/isrLeaseReducer";
import { IsrPlataformAlienationReducer } from "./accounting/IsrPlataformAlienationReducer";
import { IsrPlataformLodgingReducer } from "./accounting/IsrPlataformLodgingReducer";
import { IsrPlataformReducer } from "./accounting/IsrPlataformReducer";
import { IsrRifReducer } from "./accounting/IsrRifReducer";
import { IsrSimplifiedReducer } from "./accounting/IsrSimplifiedReducer";
import { reduccionIsrRifReducer } from "./accounting/reduccionIsrRifReducer";
import { retentionReducer } from "./accounting/retentionReducer";
import { ServiceTypeRetentionReducer } from "./accounting/serviceTypeRetentionReducer";
import { accountTypeReducer } from "./accountTypeReducer";
import { authReducer } from "./authReducer";
import { CfdiUsesBillingReducer } from "./billing/cfdiUsesBillingReducer";
import { CustomersBillingReducer } from "./billing/customersBillingReducer";
import { PaymentMethodsBillingReducer } from "./billing/paymentMethodsBillingReducer";
import { ProductsBillingReducer } from "./billing/productsBillingReducer";
import { ReceiverBillingReducer } from "./billing/receiverBillingReducer";
import { RecordInvoicesBillingReducer } from "./billing/recordInvoicesBilling";
import { RegimeBillingReducer } from "./billing/regimeBillingReducer";
import { RegisterActivateReducer } from "./billing/registerAactivateModuleReducer";
import { RegisterActivateBillReducer } from "./billing/registerActivateBillReducer";
import { TaxDocumentsBilling } from "./billing/taxDocumentsBillingReducer";
import { UserBillinReducer } from "./billing/userBillingReducer";
import { WayOfPaymentsBillingReducer } from "./billing/wayOfPaymentBillingReducer";
import { accounterReducer } from "./catalogs/accounterReducer";
import { activitiesReducer } from "./catalogs/activitiesReducer";
import { cfdiUseReducer } from "./catalogs/cfdiUseReducer";
import { coinReducer } from "./catalogs/coinReducer";
import { currencyTypeReducer } from "./catalogs/currencyTypeReducer";
import { documentTaxTaxpayerTypeReducer } from "./catalogs/documentTaxTaxpayerTypeReducer";
import { expenseClassificationsReducer } from "./catalogs/expenseClassificationsReducer";
import { geoReducer } from "./catalogs/geoReducer";
import { keyUnitReducer } from "./catalogs/keyUnitReducer";
import { paymentFrecuencieReducer } from "./catalogs/paymentFrecuencieReducer";
import { paymentGatewayReducer } from "./catalogs/paymentGatewayReducer";
import { paymentMethodReducer } from "./catalogs/paymentMethodReducer";
import { PaymentStatusReducer } from "./catalogs/PaymentStatusReducer";
import { productToSaleReducer } from "./catalogs/productToSaleReducer";
import { professionTypeReducer } from "./catalogs/professionTypeReducer";
import { receptorAccountBankReducer } from "./catalogs/receptorAccountBankReducer";
import { RegimeReducer } from "./catalogs/regimeReducer";
import { rolesReducer } from "./catalogs/rolesReducer";
import { serviceTypeReducer } from "./catalogs/serviceTypeReducer";
import { socialMediaTypeReducer } from "./catalogs/socialMediaTypeReducer";
import { thirdPartyTypeReducer } from "./catalogs/thirdPartyTypeReducer";
import { typeRetentionReducer } from "./catalogs/typeRetentionReducer";
import { unitTypeReducer } from "./catalogs/unitTypeReducer";
import { wayOfPaymentReducer } from "./catalogs/wayOfPaymentReducer";
import { zoneTypeReducer } from "./catalogs/zoneTypeReducer";
import { activitiesByRegimeReducer } from "./configuration/activitiesByRegimeReducer";
import { additionalProceduresData } from "./configuration/adittionalProcedures";
import { claveProdServReducer } from "./configuration/claveProdServReducer";
import { diagnosticApiData } from "./configuration/diagnostic";
import { monitorDownloadData } from "./configuration/downloadXML";
import { paymentApiData } from "./configuration/paymentValidate";
import { preReportUpgrade } from "./configuration/preReport";
import { preReportDetailsData } from "./configuration/preReportDetail";
import { regimesConfig } from "./configuration/regimesConfig";
import { crmPreSaleReducer } from "./crm/crmPreSaleReducer";
import { crmPromotionsReducer } from "./crm/crmPromotionsReducer";
import { crmSaleReducer } from "./crm/crmSaleReducer";
import { crmSubscriptionsReducer } from "./crm/crmSubscriptionsReducer";
import { cfdiRelationTypeReducer } from "./invoices/cfdiRelationTypeReducer";
import { localTaxeReducer } from "./invoices/localTaxeReducer";
import { InvoiceTypeReducer } from "./invoiceTypeReducer";
import { lineItemReducer } from "./lineItemReducer";
import { mailboxReducer } from "./mailbox/mailboxReducer";
import { metricReducer } from "./metric/metricReducer";
import { opinionComplementReducer } from "./opinionComplement/opinionComplementReducer";
import { packageReducer } from "./packages/packageReducer";
import { SerieFolioReducer } from "./serieFolioReducer";
import { ivaTraslated } from "./taxes/ivaTraslated";
import { taxpayerReducer } from "./taxpayerReducer";
import { certificateReducer } from "./taxpayers/certificateReducer";
import { IdentifierReducer } from "./taxpayers/identifierReducer";
import { validationSatReducer } from "./taxpayers/validationSatReducer";
import { thirdPartyReducer } from "./thirdPartyReducer";
import { uiReducer } from "./uiReducer";
import { userReducer } from "./userReducer";

import { authPartnerReducer } from "./authValidatePartner";
import { allClavProdServReducer } from "./configuration/allClavProdServReducer";
import { claveProdServNotValidatedReducer } from "./configuration/claveProdServNotValidatedReducer";
import { helpInstructionsReducer } from "./crm/getHelpDataCSV";

export const RootReducer = combineReducers({
  accountType: accountTypeReducer,
  accounter: accounterReducer,
  auth: authReducer,
  authorizationReport: authorizationReportReducer,
  certificate: certificateReducer,
  cfdiRelationType: cfdiRelationTypeReducer,
  cfdiUse: cfdiUseReducer,
  coin: coinReducer,
  crmSale: crmSaleReducer,
  crmPromotion: crmPromotionsReducer,
  complement: complementReducer,
  crmPreSale: crmPreSaleReducer,
  currencytype: currencyTypeReducer,
  customerBilling: CustomersBillingReducer,
  deductionType: deductionTypeReducer,
  documentTaxTaxpayerType: documentTaxTaxpayerTypeReducer,
  downloadXMLRequest: downloadXMLRequestReducer,
  expense: expenseReducer,
  expenseDepresiation: expenseDepresiationReducer,
  expenseType: expenseTypeReducer,
  expenseClassifications: expenseClassificationsReducer,
  identifier: IdentifierReducer,
  income: incomeReducer,
  invoiceType: InvoiceTypeReducer,
  invoiceBilling: RecordInvoicesBillingReducer,
  isrHonorarium: IsrHonorariumReducer,
  isrLease: isrLeaseReducer,
  isrSimplified: IsrSimplifiedReducer,
  isrPlataform: IsrPlataformReducer,
  isrPlataformAlienation: IsrPlataformAlienationReducer,
  isrPlataformLodging: IsrPlataformLodgingReducer,
  isrRif: IsrRifReducer,
  ivaTraslated: ivaTraslated,
  instructions: helpInstructionsReducer,
  keyUnit: keyUnitReducer,
  lineItem: lineItemReducer,
  localTaxe: localTaxeReducer,
  mail: mailboxReducer,
  packageReportAssisted: packageReducer,
  paymentFrecuencie: paymentFrecuencieReducer,
  paymentGateway: paymentGatewayReducer,
  paymentMethod: paymentMethodReducer,
  paymentMethodBillingR: PaymentMethodsBillingReducer,
  subscriptionSale: crmSubscriptionsReducer,
  paymentStatusType: PaymentStatusReducer,
  productToSale: productToSaleReducer,
  productBilling: ProductsBillingReducer,
  professionType: professionTypeReducer,
  receptorAccountBankType: receptorAccountBankReducer,
  reduccionIsrRif: reduccionIsrRifReducer,
  regime: RegimeReducer,
  regimeBilling: RegimeBillingReducer,
  registerBilling: RegisterActivateReducer,
  registerBills: RegisterActivateBillReducer,
  cfdiUsesBilling: CfdiUsesBillingReducer,
  retention: retentionReducer,
  rolesType: rolesReducer,
  serieFolio: SerieFolioReducer,
  serviceType: serviceTypeReducer,
  ServiceTypeRetention: ServiceTypeRetentionReducer,
  socialMediaType: socialMediaTypeReducer,
  taxpayer: taxpayerReducer,
  taxBillingDocuments: TaxDocumentsBilling,
  thirdParty: thirdPartyReducer,
  thirdPartyType: thirdPartyTypeReducer,
  ui: uiReducer,
  unitType: unitTypeReducer,
  userType: userReducer,
  userInvoice: UserBillinReducer,
  userData: ReceiverBillingReducer,
  validationSat: validationSatReducer,
  wayOfPayment: wayOfPaymentReducer,
  wayOfPaymentBilling: WayOfPaymentsBillingReducer,
  zoneType: zoneTypeReducer,
  zipCode: geoReducer,
  metric: metricReducer,
  typeRetention: typeRetentionReducer,
  activities: activitiesReducer,
  activitiesByRegimen: activitiesByRegimeReducer,
  regimesConfig: regimesConfig,
  preReportUpgrade: preReportUpgrade,
  preReportDetailsData: preReportDetailsData,
  monitorDownloadData: monitorDownloadData,
  additionalProceduresData: additionalProceduresData,
  diagnosticApiData: diagnosticApiData,
  paymentApiData: paymentApiData,
  clavProdServ: claveProdServReducer,
  allClavProdServ: allClavProdServReducer,
  clavProdServNotValidated: claveProdServNotValidatedReducer,
  opinionComplement: opinionComplementReducer,
  authPartner: authPartnerReducer,
  downloadXmlSatStatistics: downloadXmlSatStatisticsReducer,
});
